// extracted by mini-css-extract-plugin
module.exports = {"hero":"Z_d8"};